export default __webpack_public_path__ + "static/media/typeDrop.dcbad3ed.PNG";